import * as React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

// Stroke is fixed at the approved asset's weight; strokeWidth from props is ignored.
function TattooMachineIcon({
  size = 24,
  color = 'currentColor',
  ...props
}: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      width={size}
      height={size}
      viewBox="0 0 512 512"
      fill="none"
      stroke={color}
      strokeWidth={20}
      strokeLinecap="round"
      strokeLinejoin="round">
      <g transform="matrix(1,0,0,-1,0,512)">
        <path
          transform="translate(72.9697,70.9033)"
          d="m 0,0 -45.483,26.26 c -12.588,7.267 -16.9,23.362 -9.633,35.95 l 67.679,117.225 c 7.268,12.586 23.363,16.899 35.95,9.631 l 45.484,-26.259 c 12.587,-7.267 16.899,-23.363 9.632,-35.95 L 35.95,9.633 C 28.682,-2.954 12.587,-7.268 0,0 Z"
        />
        <path
          transform="translate(70.0249,72.6035)"
          d="m 0,0 -39.594,22.859 -20.114,-34.838 -0.317,-46.268 39.911,23.408 z"
        />
        <path
          transform="translate(209.7402,314.5977)"
          d="m 0,0 15.85,27.453 c 3.871,6.705 1.574,15.279 -5.131,19.151 l -15.312,8.84 c -6.705,3.871 -15.28,1.574 -19.151,-5.131 l -15.85,-27.454"
        />
        <path
          transform="translate(147.2866,297.8633)"
          d="M 0,0 -22.859,-39.594 16.735,-62.453 39.594,-22.86"
        />
        <path
          transform="translate(412.0674,171.3877)"
          d="M 0,0 V 0 C 6.312,10.934 2.566,24.914 -8.367,31.227 L -261.718,177.499 -284.578,137.905 -31.227,-8.367 C -20.293,-14.68 -6.312,-10.934 0,0 Z"
        />
        <path
          transform="translate(349.2559,434.6562)"
          d="M 0,0 -72.446,41.827 -95.306,2.233 118.451,-121.18 c 10.934,-6.312 24.914,-2.566 31.227,8.367 6.312,10.934 2.566,24.915 -8.367,31.227 l -63.378,36.592"
        />
        <path transform="translate(87.8965,332.1523)" d="M 0,0 22.859,39.594" />
        <path
          transform="translate(99.3257,351.9492)"
          d="M 0,0 39.594,-22.859"
        />
        <path
          transform="translate(358.4648,376.5479)"
          d="m 0,0 -19.017,10.979 c -14.428,8.331 -32.879,3.387 -41.21,-11.041 l -33.838,-58.611 c -8.331,-14.43 -3.387,-32.88 11.042,-41.21 l 19.016,-10.979 c 14.43,-8.331 32.88,-3.387 41.21,11.042 l 33.839,58.61 C 19.373,-26.781 14.429,-8.33 0,0 Z"
        />
        <path
          transform="translate(429.7334,335.4014)"
          d="m 0,0 -19.017,10.979 c -14.428,8.331 -32.879,3.386 -41.21,-11.042 l -33.838,-58.611 c -8.331,-14.429 -3.387,-32.879 11.043,-41.21 l 19.016,-10.979 c 14.429,-8.33 32.879,-3.387 41.21,11.042 l 33.838,58.61 C 19.373,-26.781 14.43,-8.331 0,0 Z"
        />
        <path
          transform="translate(212.8032,365.6211)"
          d="M 0,0 76.223,132.022"
        />
        <path transform="translate(388.2217,412.1592)" d="M 0,0 V 0" />
      </g>
    </svg>
  );
}
export default TattooMachineIcon;
